module.exports = __webpack_public_path__ + "img/behringer-sf300-super-fuzz.b83e7691.jpg";